import { BaseApiService } from "./baseApiService";

export interface SummaryParams {
  searchText?: string;
  policyCode?: string;
  documentType?: string;
  documentCategory?: string;
  documentSubCategory?: string;
  policyLanguage?: string;
  publishedSince?: Date | null;
}

export interface SummaryResponse {
  answer: string;
}

class SummaryService extends BaseApiService {
  async getSummary(params: SummaryParams, options?: { signal?: AbortSignal }): Promise<SummaryResponse> {
    const urlSearchParams = new URLSearchParams({
      searchText: params.searchText || "",
    });

    if (params.policyCode && params.policyCode.trim()) {
      urlSearchParams.append("policyCode", params.policyCode.trim());
    }

    if (params.documentType && params.documentType.trim()) {
      urlSearchParams.append("documentType", params.documentType.trim());
    }

    if (params.documentCategory && params.documentCategory.trim()) {
      urlSearchParams.append("documentCategory", params.documentCategory.trim());
    }

    if (params.documentSubCategory && params.documentSubCategory.trim()) {
      urlSearchParams.append("documentSubCategory", params.documentSubCategory.trim());
    }

    if (params.policyLanguage && params.policyLanguage.trim()) {
      urlSearchParams.append("documentLanguage", params.policyLanguage.trim());
    }

    if (params.publishedSince) {
      const d = params.publishedSince;
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      const yyyymmdd = `${yyyy}-${mm}-${dd}`;
      urlSearchParams.append("publishedSinceDate", yyyymmdd);
    }

    const response = await BaseApiService.get({
      url: `/summary?${urlSearchParams.toString()}`,
      responseDefaults: {},
      signal: options?.signal,
    });

    if (response.success) {
      return response as unknown as SummaryResponse;
    } else {
      // Preserve backend-provided errorCode for callers to distinguish 403
      const message = (response as { error?: string }).error || "Failed to get summary response";
      const error = new Error(message) as Error & { code?: string };
      const errorCode = (response as { errorCode?: string }).errorCode;
      if (errorCode) {
        error.code = errorCode;
      }
      throw error;
    }
  }
}

export const summaryService = new SummaryService();



